<template>
  <div>
    <v-snackbar
      v-model="estatusAdd"
      bottom
      color="accent"
      right
    >
      <v-icon size="25"> mdi-cart </v-icon>Agregando Articulo...
    </v-snackbar>
    <btnAddNew
      :mytext="textbtn"
      :iniciacar="verBtn"
      :setiniciar="handleBtn"
      v-if="
        validaBtnCarga(
          $route,
          selcliente,
          ver,
          verBtn,
          userAuth,
          item,
          dataUser
        )
      "
    />
    <v-card
      v-if="validaInputCarga($route, selcliente, userAuth, ver, verBtn, item)"
      :class="[
        'd-flex',
        'mx-auto',
        'mt-1',
        { 'justify-space-between': tipoConsulta === 1 },
      ]"
      flat
      tile
      color="transparent"
    >
      <v-card-actions>
        <v-btn
          small
          fab
          color="primary"
          depressed
          text
        >
          <v-icon
            @click.stop="
              count > 1 ? count-- : (handleBtn(true), null);
              ValidaCantidadPromo(codArt, cantArt);
            "
            size="30"
          >
            mdi-minus
          </v-icon>
        </v-btn>
        <v-text-field
          color="primary"
          dense
          :label="`${formatNumber(
            contCantidad({ contmayor: item.ContentMayor, cant: count })
          )} ${item.UniVenta}`"
          hide-details
          v-model="count"
          type="tel"
          @keypress="isNumber($event)"
          @change="ValidaCantidadPromo(codArt, count)"
          @input="ValidaCantidadPromo(codArt, count)"
          @click.stop="isNumber($event)"
          class="warning-200"
          style="width: 70px; font-size: 1.3rem"
          reverse
        ></v-text-field>
        <v-btn
          small
          fab
          color="primary"
          depressed
          text
        >
          <v-icon
            @click.stop="
              count < contenidoMayor({ item }) ? count++ : null;
              ValidaCantidadPromo(codArt, count);
            "
          >
            mdi-plus
          </v-icon>
        </v-btn>
      </v-card-actions>

      <v-card
        :class="[{ 'mx-6': tipoConsulta === 2 }]"
        flat
        color="transparent"
      >
        <v-btn
          class="mt-3"
          icon
          :disabled="
            snackbar ||
            contCantidad({ contmayor: item.ContentMayor, cant: count }) === 0
          "
          :loading="estatusAdd"
          color="primary"
          @click.stop="
            AdPromo || !promo
              ? (AgregarP(codArt), (estatusAdd = true))
              : (snackbar = true)
          "
        >
          <v-badge
            v-if="isCar(codArt) === 0"
            color="info"
            left
            :content="validaContenido ? 'Paleta' : 'Bulto'"
          >
            <v-icon v-if="isCar(codArt) === 0" size="30" color="accent">
              mdi-cart-plus
            </v-icon>
          </v-badge>
          <v-progress-circular
            v-if="promo && detallePromocion(codArt).length === 0 && snackbar"
            indeterminate
            color="grey"
            size="17"
            :width="2"
          ></v-progress-circular>
          <v-badge
            v-if="isCar(codArt) !== 0"
            color="info"
            left
            :content="ItemArtCar(codArt)"
          >
            <v-icon
              v-if="isCar(codArt) !== 0"
              size="30"
              color="primary"
            >
              mdi-cart-check
            </v-icon>
          </v-badge>
        </v-btn>
      </v-card>
    </v-card>

    <!-- Snackbar AdPromo-->
    <div
      v-if="tamPromocion(codArt) != 0"
      class="text-center mt-n2"
    >
      <v-menu
        v-model="snackbar"
        @keydown.esc="snackbar = false"
        bottom
        right
        transition="scale-transition"
        offset-y
        :close-on-content-click="false"
      >
        <template v-slot:activator="{ on }">
          <span v-on="on"> </span>
        </template>
        <v-card width="400">
          <v-toolbar
            color="primary"
            dark
            dense
            height="28"
          >
            <v-container>
              <v-layout row>
                <span :class="['mx-auto', 'subtitle-2']">
                  PROMOCION{{ tamPromocion(codArt) > 1 ? "ES" : "" }} PARA: {{ codArt }}
                </span>
              </v-layout>
            </v-container>
            <v-spacer></v-spacer>
            <v-btn icon @click="snackbar = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-overlay absolute :value="tamPromocion(codArt) === 0">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
            Cargando Promociones
          </v-overlay>
          <v-card
            width="400"
            tile
            flat
          >
            <v-list-item
              v-for="(itemPromo, i) in detallePromocion(codArt)"
              :key="i"
              three-line
            >
              <v-list-item-content>
                <v-list-item-title>
                  Cantidad Minima:
                  <span class="font-weight-bold">
                    {{  `${itemPromo["cantidad-min"]/itemPromo["ContenidoMayor"]} ${validaContenido ? 'Paleta' : ' Uni'}` }}
                  </span>
                  <span class="text--secondary"> |</span>
                  Dto:
                  <span class="font-weight-bold">
                    {{ ` ${itemPromo["descuento"]}%` }}
                  </span>
                </v-list-item-title>
                <v-list-item-title
                  v-if="dataUser.VerPrecios[tipoMoneda]"
                  class="body-1"
                >
                  Precio:
                  <span class="font-weight-bold">
                    {{ `${simboloMoneda[tipoMoneda]}` }}
                    {{ itemPromo["PrecioExt-paq"] | numeral("0,0.00") }}
                  </span>
                  <span class="text--secondary">|</span>
                  Ahorre:
                  <span
                    class="font-weight-bold"
                    v-if="dataUser.VerPrecios[tipoMoneda]"
                  >
                    {{ `${simboloMoneda[tipoMoneda]}`}}
                    {{ itemPromo["MontoExtDes"] | numeral("0,0.00") }}
                  </span>
                </v-list-item-title>
                <v-list-item-subtitle class="mt-2">
                  <btnPromo
                    @sel-promo="detallePromocion(codArt), (snackbar = false)"
                    :codArt="codArt"
                    :codPromo="itemPromo.codigo"
                    :tipoConsulta="1"
                    :titulo="`Cargar Promoción`"
                    :infoproducto="item"
                  ></btnPromo>
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-card>
          <v-divider color="#D3BC8D" />
          <v-card-actions v-if="tamPromocion(codArt) != 0">
            <v-spacer></v-spacer>
            <v-btn
              v-if="isCar(codArt) === 0"
              color="info"
              elevation="0"
              dark
              @click.stop="
                set_AdPromoT();
                AgregarP(codArt);
                estatusAdd = true;
                snackbar = false;
              "
            >
              <v-badge color="accent" :content="cantArt">
                Continuar <v-icon>mdi-cart-variant</v-icon>
              </v-badge>
            </v-btn>
            <v-btn
              v-if="isCar(codArt) !== 0"
              color="primary"
              dark
              @click="snackbar = false"
            >
              Cerrar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-menu>
    </div>
  </div>
</template>

<script>
  import { mapState, mapActions, mapMutations, mapGetters } from "vuex";
  import btnPromo from "./botonselpromo";
  import btnAddNew from "./btnAddNew";

  export default {
    name: "btnAdd",
    data() {
      return {
        menu: false,
        count: 1,
        overlay: false,
        sbpromo: false,
        msgpromo: null,
        cantArt: 1,
        datosPromo: [],
        verBtn: true,
        estatusAdd: false,
        snackbar: false,
      };
    },
    components: {
      btnPromo,
      btnAddNew,
    },
    computed: {
      ...mapState([
        "PromocionAll",
        "AdPromo",
        "dataUser",
        "tipoMoneda",
        "simboloMoneda",
        "Articulo",
        "ttArticuloAll",
        "Pedido",
      ]),
      ...mapGetters(["filterpromo"]),
      isCar: function () {
        return function (cod) {
          return this.Pedido.items
            .filter((x) => x["Codigo"] === cod)
            .map((x) => x["Codigo"]).length;
        };
      },
      validaContenido() {
        const { ContentDetal } = this.item;
        return ContentDetal !== 1;
      },
      contenidoMayor: function () {
        return function ({ item }) {
          const ruta = this.$route.name;
          const itemContenido = ruta === "Detalle" ? `DisponNum` : `Disponible`;
          const { [itemContenido]: Disponible, EnTransito, ContentMayor } = item;
          if (this.dataUser.TipoUsuario === "U") return 100;
          else
            return ContentMayor !== 0
              ? item.Stock +
                  Math.trunc(EnTransito / ContentMayor)
              : null;
        };
      },
      contCantidad: function () {
        return function ({ contmayor, cant }) {
          return contmayor * cant;
        };
      },
      validaContenido() {
        const { ContentDetal } = this.item;
        return ContentDetal !== 1;
      },
      ItemArtCar: function () {
        return function (cod) {
          return this.Pedido.items
            .filter((x) => x["Codigo"] === cod)
            .map((x) => x["Cantidad"])
            .toString();
        };
      },
      ValidaCantidadPromo: function () {
        return function (a, c) {
          let p = [];
          let indexPromo = [];
          if (this.promo && this.filterpromo) {
            p = this.filterpromo.filter(
              (x) => x["articulo"] == a && (c * x["ContenidoMayor"]) >= x["cantidad-min"]
            );
            p.forEach((x) => {
              indexPromo.push(x["cantidad-min"]);
            });
          }
          if (p.length > 0) {
            let xindexPromo = indexPromo.reduce((prev, curr) =>
              Math.abs(curr - c) < Math.abs(prev - c) ? curr : prev
            );
            let findexPromo = indexPromo.findIndex((x) => xindexPromo === x);

            this.datosPromo = p[findexPromo];
            this.set_AdPromoT();
            this.$emit("promoArticulo", p, this.cantArt, true, a);
            return true;
          } else {
            this.set_AdPromoF();
            this.datosPromo = [];
            this.$emit("promoArticulo", [], this.cantArt, false, null);
            return false;
          }
        };
      },
      detallePromocion: function () {
        return function (id) {
          if (this.filterpromo)
            return this.filterpromo.filter((x) => id === x["articulo"]);
        };
      },
      tamPromocion: function () {
        return function (id) {
          if (this.filterpromo)
            return this.filterpromo.filter((x) => id === x["articulo"]).length;
        };
      },
    },
    mounted() {
      this.ValidaCantidadPromo(this.codArt, this.cantArt);
    },
    methods: {
      ...mapActions([
        "set_cargaArtCarrito",
        "get_ConsultaPedido",
        "cargarDatosArtCar",
      ]),
      ...mapMutations([
        "set_AdPromoT",
        "set_AdPromoF",
        "set_mensaje",
      ]),
      handleBtn(val) {
        this.verBtn = val;
      },
      formatNumber(num) {
        return parseFloat(num).toFixed(2);
      },
      async AgregarP(cod) {
        let codPromo = "";
        if (this.datosPromo.length != 0) {
          codPromo = this.datosPromo.codigo;
        } else {
          codPromo = 0;
        }

        await this.set_cargaArtCarrito({
          articulo: cod,
          cantidad: this.formatNumber(
            this.contCantidad({
              contmayor: this.item.ContentMayor,
              cant: this.count,
            })
          ),
          promo: codPromo,
        });
        await this.set_mensaje({
          Visible: true,
          Msj: "Articulo Cargado",
          Type: "success",
        });
        await this.cargarDatosArtCar({ codart: cod });
        await this.get_ConsultaPedido();
        this.set_AdPromoF();
        this.estatusAdd = false;
        this.cantArt = 1;
      },
      isNumber: function (evt) {
        let charCode = evt.which ? evt.which : evt.keyCode;
        let inputElement = evt.target;
        let currentValue = inputElement.value;
        let newValue = parseFloat(currentValue + String.fromCharCode(charCode));
        let isMaximo = newValue > this.contenidoMayor({ item: this.item });
        if (
          (charCode > 31 && (charCode < 48 || charCode > 57)) ||
          (isMaximo && charCode != 9)
        ) {
          evt.preventDefault();
        } else {
          return true;
        }
      },
      validaBtnCarga: (route, selCli, ver, verBtn, userAuth, item, user) => {
        const ruta = route.name;
        if (ruta === "Detalle" || ruta === "CarritoCompras") return false;
        if (user.TipoUsuario === "U") return !selCli && ver && verBtn && userAuth;
        else
          return (
            !selCli &&
            ver &&
            verBtn &&
            userAuth &&
            item.Disponible + item.EnTransito > 0
          );
      },
      validaInputCarga(route, selCli, userAuth, ver, verBtn, item) {
        const ruta = route.name;
        const Dispon = item.Disponible + item.EnTransito
        const TipUser = (this.dataUser.TipoUsuario === "U" ? true : Dispon > 0)
        if (ruta === "Categoria") return !selCli && userAuth && !verBtn;
        if (ruta === "CarritoCompras")
          return !selCli && userAuth && TipUser;
        if (ruta === "Articulos")
          return (
            !selCli &&
            userAuth &&
            !verBtn &&
            TipUser
          );
        if (this.dataUser.TipoUsuario === "U") return !selCli && userAuth && ver;
        else
          return (
            !selCli && userAuth && ver && item.DisponNum + item.EnTransito > 0
          );
      },
    },
    props: {
      selcliente: Boolean,
      userAuth: Boolean,
      codArt: String,
      promo: Boolean,
      ver: Boolean,
      tipoConsulta: Number,
      textbtn: String,
      item: Object | Array,
    },
  };
</script>

<style scoped>
  .btnaddcart {
    font-weight: 500;
    font-size: 0.8rem;
  }
  .quantity2 {
    font-size: 1rem;
    width: 70px;
    height: 42px;
    font-weight: 700;
    text-align: start;
    border: 1px solid rgb(97, 96, 96);
  }
  .quantity {
    font-size: 1.3rem;
    width: 70px;
    height: 35px;
    font-weight: 700;
  }
  .centered-input >>> input {
    text-align: center;
  }
  .quantity-btn {
    height: 42px;
    width: 50px;
    font-size: 2rem;
    display: flex;
    border: 1px solid red;
    text-align: center;
    font-weight: 300;
    border-radius: 10;
    box-shadow: none;
    margin: 0 15px 0 0;
    background: #fff;
    box-sizing: border-box;
  }
  h1 {
    border-bottom: 5px solid #d3bc8d;
  }
  .style-badge {
    width: auto; /* Ajusta el ancho automáticamente según el contenido */
    border-radius: 18px; /* Radio de la esquina del badge */
    padding: 5px 1px; /* Espaciado interno del badge */
    /* Puedes ajustar el 'font-size' para cambiar el tamaño del texto dentro del badge */
  }
</style>
